import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { adminService } from '@/services/collections/admin';
import { useAuth } from '@/contexts/AuthContext';
import type { UserPlan } from '@/utils/planLimits';

export const useAdminAccess = () => {
  const { user } = useAuth();
  return adminService.checkAdminAccess(user?.email);
};

export const useUserReport = () => {
  const { user } = useAuth();
  const hasAccess = useAdminAccess();

  return useQuery({
    queryKey: ['admin', 'userReport'],
    queryFn: () => adminService.getUserReport(user!.email!),
    enabled: hasAccess && !!user?.email,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useUpdateUserPlan = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, plan }: { userId: string; plan: UserPlan }) =>
      adminService.updateUserPlan(user!.email!, userId, plan),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'userReport'] });
    },
  });
};
